/*=============== Base URL ============*/
export const API_BASE_URL = "https://api.alfathbelajar.com/";

/*================ Getters ============*/
// General / Shared
export const PAGE_TITLE = "pageTitle";
export const COLLAPSE = "collapse";
export const OVERLAY = "overlay";

// auth module
export const IS_LOGGED_IN = "isLoggedIn";
export const USER = "user";

//content
export const SECTION = "section";
export const CONTENT = "content";
export const QUIZ = "quiz";
export const QUIZ_RESULT = "quizResult";
export const TRYOUT = "tryout";
export const TRYOUT_RESULT = "tryoutResult";
export const TRYOUT_ONGOING = "tryoutOngoing";
export const NEW_NOTIF = "newNotif";

/*============= Mutations ===============*/
// General / Shared
export const MUTATE_SET_PAGE_TITLE = "mutateSetPageTitle";
export const MUTATE_SET_OVERLAY = "mutateOverlay";
export const MUTATE_SET_COLLAPSE = "mutateCollapse";

// auth module
export const MUTATE_LOGIN = "mutateLogin";
export const MUTATE_LOGOUT = "mutateLogout";
export const MUTATE_NOTIF = "mutateNotif";

//content
export const MUTATE_SECTION = "mutateSection";
export const MUTATE_CONTENT = "mutateContent";
export const MUTATE_QUIZ = "mutateQuiz";
export const MUTATE_QUIZ_RESULT= "mutateQuizResult"
export const MUTATE_TRYOUT = "mutateTryout";
export const MUTATE_TRYOUT_RESULT= "mutateTryoutResult";
export const MUTATE_TRYOUT_ONGOING= "mutateTryoutOngoing";

/*=============== Actions =================*/
// General / Shared
export const SET_PAGE_TITLE = "setPageTitle";
export const SET_OVERLAY = "setOverlay";
export const SET_COLLAPSE = "setCollapse";

// auth module
export const LOGIN_VERIFY = "loginVerify";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const UPDATE_NOTIF = "updateNotif";

//content
export const GET_SECTION_DETAIL = "getSectionDetail";
export const GET_CONTENT_LIST = "getContentList";
export const GET_CONTENT_DETAIL = "getContentDetail";
export const GET_QUIZ_LIST = "getQuizList";
export const GET_QUIZ_DETAIL = "getQuizDetail";
export const END_QUIZ = "endQuiz";
export const GET_TRYOUT_DETAIL = "getTryoutDetail";
export const START_TRYOUT_PACKAGE = "startTryoutPackage";
export const END_TRYOUT_PACKAGE = "endTryoutPackage";
export const END_TRYOUT = "endTryout";
export const START_TRYOUT = "startTryout";
export const GET_TRYOUT_RESULT = "GET_TRYOUT_RESULT";
export const GET_TRYOUT_HISTORY = "GET_TRYOUT_HISTORY";
export const FORUM_SECTION_LIST = "forumSectionList";
export const FORUM_REPLY_LIST = "forumReplyList";
export const FORUM_CREATE = "forumCreate";
export const FORUM_DETAIL = "forumDetail";
export const FORUM_REPLY = "forumReply";

export const NOTIF_LIST = "notifList";
export const NOTIF_UNREAD = "notifUnread";

